import { react2angular } from 'react2angular';
import { AlarmRuleReportModal } from './alarm-rule/AlarmRuleReportModal';
import { AlarmEventReportModal } from './alarm-event/AlarmEventReportModal';

angular.module('webtip.module')
  .component('alarmRuleReportModal', react2angular(AlarmRuleReportModal, ['rule', 'onClose'], [
    'alarmRuleReportService', 'alarmNotificationService', '$translate',
  ]))
  .component('alarmEventReportModal', react2angular(AlarmEventReportModal, [
    'reportPayload', 'criteriaSummary', 'onClose', 'onCreateRule',
  ], ['alarmRuleReportService', 'alarmNotificationService', 'dateFilter', '$translate']))
  .component('alarmRuleReportDialog', {
    bindings: { resolve: '<', dismiss: '&' },
    template: '<alarm-rule-report-modal rule="$ctrl.resolve.rule" on-close="$ctrl.dismiss"></alarm-rule-report-modal>',
  })
  .component('alarmEventReportDialog', {
    bindings: { resolve: '<', dismiss: '&' },
    template: '<alarm-event-report-modal report-payload="$ctrl.resolve.reportPayload" criteria-summary="$ctrl.resolve.criteriaSummary" on-close="$ctrl.dismiss" on-create-rule="$ctrl.resolve.createRuleFromReport"></alarm-event-report-modal>',
  });